import { CheckboxItem, MenuTop, Output, Text } from '@components';
import { FacialExpressionChildOptionValueEnum, styleConstant } from '@constant';
import { useOutput } from '@hooks';
import { colorSet } from '@theme';
import { useEffect, useState } from 'react';
import { useFacialExpressionActions } from '@remote-hooks';
import { FaceAngryIcon, FaceDisgustIcon, FaceEmbarrassedIcon } from '@assets/iconComponents';

const FacialExpressionOutputPage = () => {
  const { storedFacialExpressionChildOptionValue, onSetFacialExpression } = useOutput();

  // 마운트 상태를 추적하는 state
  const [isComponentMounted, setIsComponentMounted] = useState(false);

  const { onInitFacialExpression } = useFacialExpressionActions();

  useEffect(() => {
    setIsComponentMounted(true);
    if (!isComponentMounted) return;

    return () => {
      onInitFacialExpression();
    };
  }, [isComponentMounted, onInitFacialExpression]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <MenuTop />

      {/* 옵션 */}
      <div
        style={{
          height: styleConstant.topPageNameHeight,
          padding: '40px',
          borderBottom: `1px solid ${colorSet.gray300}`
        }}
      >
        <Text variant="h2" fontWeight="bold">
          표정
        </Text>
      </div>

      <div style={{ display: 'flex' }}>
        {/* 좌측 메뉴 */}
        <div
          style={{
            width: styleConstant.outputPageLeftMenuWidth,
            padding: '24px 32px',
            backgroundColor: colorSet.gray100,
            boxSizing: 'border-box',
            position: 'sticky',
            top: styleConstant.menuTopHeight,
            minHeight: `calc(100vh - ${styleConstant.menuTopHeight + styleConstant.topPageNameHeight}px)`,
            maxHeight: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            borderRight: `1px solid ${colorSet.gray300}`
          }}
        >
          <Text variant="body1" fontWeight="bold">
            하위 스페셜 단추
          </Text>
          <div style={{ width: 224, padding: '8px 24px 8px 0px', marginTop: '8px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '24px 0px' }}>
              <CheckboxItem
                label="혐오"
                imageComponent={<FaceDisgustIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.혐오]}
                onChange={() => {
                  onSetFacialExpression({
                    [FacialExpressionChildOptionValueEnum.혐오]:
                      !storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.혐오]
                  });
                }}
              />
              <CheckboxItem
                label="분노"
                imageComponent={<FaceAngryIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.분노]}
                onChange={() => {
                  onSetFacialExpression({
                    [FacialExpressionChildOptionValueEnum.분노]:
                      !storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.분노]
                  });
                }}
              />
              <CheckboxItem
                label="당황"
                imageComponent={<FaceEmbarrassedIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.당황]}
                onChange={() => {
                  onSetFacialExpression({
                    [FacialExpressionChildOptionValueEnum.당황]:
                      !storedFacialExpressionChildOptionValue[FacialExpressionChildOptionValueEnum.당황]
                  });
                }}
              />
            </div>
          </div>
        </div>

        {/* 검색 결과 */}
        <Output />
      </div>
    </div>
  );
};

export default FacialExpressionOutputPage;
